import React, { useEffect, useState } from 'react';
import Select, { SingleValue } from 'react-select';
import RoundDetails from './RoundDetails';
import { GetAllMeetingsDetailAPIResponse, MeetingDetails, Question, RoundType } from 'types';
import { Dropdown } from 'shared-utils';
import TechRoundQuestionsContainer from './TechRoundQuestionsContainer';
import TechnicalRoundRecordingsEmptyState from './TechnicalRoundRecordingsEmptyState';
import InterviewSummaryAndVideoRecording from './InterviewSummaryAndVideoRecording';
import { useUserContext } from 'src/context/UserProvider';
import ProfileContentHeader from '../ProfileContentHeader';

interface Props {
	title: string;
	meetings?: MeetingDetails[] | undefined;
}
const TechnicalRoundRecordingsContainer = ({ title, meetings }: Props) => {
	const { isAccountManagerLoggedIn, isRecruiterLoggedIn } = useUserContext();

	const [roundOptions, setRoundOptions] = useState<
		{
			label: string;
			value: string;
		}[]
	>([]);
	const [selectedRound, setSelectedRound] = useState<{
		label: string;
		value: string;
	}>();
	const [selectedRoundMeetingDetails, setSelectedRoundMeetingDetails] = useState<MeetingDetails>();
	const [tab, setTab] = useState<{
		index: number;
		roundType: RoundType;
	}>({
		index: 0,
		roundType: RoundType.HLD,
	});
	const [questionsData, setQuestionsData] = useState<
		{
			question: Question;
			score: number;
			timeTaken: number;
			questionType: RoundType;
			assessedSkills: { _id: string; name: string; isSoftSkill: boolean }[];
		}[]
	>([]);

	useEffect(() => {
		if (isAccountManagerLoggedIn || isRecruiterLoggedIn) {
			const temp = selectedRoundMeetingDetails?.roundData.find(rd => rd.roundType === tab.roundType);
			if (temp?.questionsData) setQuestionsData(temp.questionsData);
		} else {
			if (selectedRoundMeetingDetails?.roundCombinedQuestionsData)
				setQuestionsData(selectedRoundMeetingDetails?.roundCombinedQuestionsData);
		}
	}, [tab, selectedRoundMeetingDetails, isAccountManagerLoggedIn, isRecruiterLoggedIn]);

	useEffect(() => {
		if (meetings?.length) {
			// create dropdown options
			const temp = meetings
				.filter(m => m.meetingRecordings?.length)
				.map(m => ({
					label: m.meetingDetails.title?.replaceAll('_', ' ')?.trim() ?? '',
					value: m._id,
				}));
			console.log(temp, meetings);
			setRoundOptions(temp);
			setSelectedRound(temp[0]);
		}
	}, [meetings]);

	useEffect(() => {
		const temp = meetings?.find(m => m._id === selectedRound?.value);
		setSelectedRoundMeetingDetails(temp);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedRound]);

	useEffect(() => {
		if (selectedRoundMeetingDetails) {
			if (selectedRoundMeetingDetails?.roundData?.length) {
				setTab({
					index: 0,
					roundType: selectedRoundMeetingDetails.roundData[0].roundType,
				});
			}
		}
	}, [selectedRoundMeetingDetails]);

	return (
		<>
			<ProfileContentHeader data={{ name: title, isImp: false }} />
			{meetings?.length ? (
				<div className="bg-transparent dark:bg-[#1F2A37] rounded-[12px] overflow-hidden p-3">
					<div className="sm:px-2 px-2 py-[14px]">
						<div className="flex gap-4 items-center">
							<div className="text-sm font-medium text-[#28293D] dark:text-[#C7C9D9] min-w-[85px]">Select round</div>
							<div className="w-[300px]">
								<Select
									menuPlacement={'auto'}
									classNamePrefix="my-select-plans"
									instanceId="graduation_year"
									className="single-value-select-tag"
									options={roundOptions}
									value={selectedRound}
									onChange={(val: SingleValue<Dropdown>) => {
										if (val?.value) {
											setSelectedRound(val);
										}
									}}
								/>
							</div>
						</div>

						{/* round details */}
						<div className="mt-5">
							<RoundDetails
								data={{
									overallRoundScore:
										typeof selectedRoundMeetingDetails?.meetingDetails?.meetingScore === 'number'
											? Number(selectedRoundMeetingDetails?.meetingDetails?.meetingScore?.toFixed(2))
											: 0,
									skillsAssesed: [], // sending empty array for now
									interviewedByData: {
										name: selectedRoundMeetingDetails?.meetingDetails.hostDetails?.name ?? '',
										img: selectedRoundMeetingDetails?.meetingDetails.hostDetails?.imageURL ?? '',
										company: selectedRoundMeetingDetails?.meetingDetails.hostDetails?.currentCompany ?? '',
										role: selectedRoundMeetingDetails?.meetingDetails.hostDetails?.currentRole ?? '',
										linkedinUrl: selectedRoundMeetingDetails?.meetingDetails.hostDetails?.linkedUrl ?? '',
									},
									interviewedOnData: {
										duration: selectedRoundMeetingDetails?.meetingDetails.duration ?? 0,
										startTime: String(selectedRoundMeetingDetails?.meetingDetails.meetingStartTime) ?? '',
									},
								}}
							/>
						</div>

						{/* interview summary and video recording */}
						<InterviewSummaryAndVideoRecording recordings={selectedRoundMeetingDetails?.meetingRecordings ?? []} />

						{/* tech round questions asked */}
						<div className="mt-6">
							<TechRoundQuestionsContainer
								tab={tab}
								setTab={setTab}
								selectedRoundMeetingDetails={selectedRoundMeetingDetails}
								questionsData={questionsData}
							/>
						</div>
					</div>
				</div>
			) : (
				<TechnicalRoundRecordingsEmptyState />
			)}
		</>
	);
};

export default TechnicalRoundRecordingsContainer;
